const accessKey = "audience.accessToken";
const refreshKey = "audience.refreshToken";

export interface SessionTokens {
  access: string;
  refresh: string;
}

export function readSession(): SessionTokens | null {
  const access = sessionStorage.getItem(accessKey);
  const refresh = sessionStorage.getItem(refreshKey);
  if (!access || !refresh) return null;
  return { access, refresh };
}

export function writeSession(tokens: SessionTokens) {
  sessionStorage.setItem(accessKey, tokens.access);
  sessionStorage.setItem(refreshKey, tokens.refresh);
}

export function clearSession() {
  sessionStorage.removeItem(accessKey);
  sessionStorage.removeItem(refreshKey);
}
